import React, { useContext, useState, useEffect } from 'react'
import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import CodeMirrorWrapper from 'live/components/codemirror/codemirror'
import styled from 'styled-components'
import api from '../api'

// require('codemirror/mode/javascript/javascript')
// require('codemirror/addon/comment/comment')

const codeMirrorOptions = {
    mode: 'text/javascript',
    matchBrackets: true,
    lineNumbers: true,
    foldGutter: true,
    // extraKeys: {
    //     'Ctrl-/': toggleComment
    // }
}

const SourceConfig = ({ company }) => {
    const [code, setCode] = useState<string>("")

    function fetchExpression() {
        const controller = new AbortController()
        const signal = controller.signal

        api.getExpression(signal, company).then(response => {
            if (response.ok) {
                response.json().then((data) => {
                    setCode(data.expression)
                })
            }
        })

        return () => controller.abort()
    }

    function onSave() {
        api.saveExpression(company, { expression: encodeURI(code) })
            .then(response => {
                if (response.ok) {
                    globalNotification.success(i18n('Saved successfully.'))
                    window.location.reload()
                } else {
                    globalNotification.error(i18n('Error occurred while saving.'))
                    console.error(response)
                }
            })
    }

    useEffect(() => {
        fetchExpression()
    }, [])

    // useEffect(() => {
    //     console.log('code', JSON.stringify(code), encodeURI(code));
    // }, [code])

    return (
        <StyledContainer>
            <div className='container'>
                <div className='title'>{company == 'offshore' ? 'OFFSHORE' : 'ONSHORE'} ILT PROGRAMS SOURCE PIPES QUERY</div>
                {/* <textarea value={code} onChange={(e) => setCode(e.target.value)} /> */}
                <CodeMirrorWrapper value={code} onChange={(e) => setCode(e)} options={codeMirrorOptions} />
                <Footer>
                    <button
                        className="btn btn-primary"
                        onClick={onSave}
                    >
                        Save
                    </button>
                </Footer>
            </div>
        </StyledContainer>
    )
}

const Footer = styled.div`
    margin: 10px;
`

const StyledContainer = styled.div`
    @media (min-width: 992px)
    .container {
        width: 970px;
    }

    .container {
        padding: 20px;

        .title {
            font-size: 16px;
            margin: 10px 0px;
            font-weight: 700;
        }

        .console-content {
            min-height: 140px;
            height: 100%;
            border: solid 1px lightgray;
        }

        .CodeMirror {
            height: 450px !important;
        }

        .has-error, .help-block {
            color: var(--brand-danger) !important;
        }
    }
`

export default SourceConfig